import Vue from 'vue'
import Vuex from 'vuex'
import axios from '@/api/index'

import Nprogress from 'nprogress';
import globalAxios from 'axios'

import router from '@/router/index'
import qs from 'qs'
Vue.use(Vuex)
const state = {
    analyticsData: [],
}
const mutations = {
    SET_ANALYTICS_DATA(state, data) {
        state.analyticsData = data;

    },

}
const actions = {
    fetchAnalyticsData({
        commit,
        dispatch
    }, authData) {
        Nprogress.start();
        axios.get('/analytics/analytics_list')
            .then(res => {
                Nprogress.done()
                if (res.data.status == "redirect") {
                    router.push("/dashboard");
                  } else {
                commit("SET_ANALYTICS_DATA", res.data);
                  }
            })
            .catch(error => console.log(error))
    },
    getInitialGraph({
        commit,
        dispatch
    }, authData) {
        return new Promise((resolve, reject) => {
            //Nprogress.start()
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.get("/analytics/" + authData.type + "/" + authData.timeRange + "/" + authData.apGroup + "/" + authData.account)
                .then(response => {
                    loader.hide();
                    resolve(response.data)

                })
                .catch(error => console.log(error));
        });
    },
    socialLogOnLike1({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            //Nprogress.start()
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/CpConfiguration/social_logon_like', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status == "redirect") {
                        router.push("/dashboard");
                    }
                    else if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
}
const getters = {
    analyticsdataGetter: state => {
        return state.analyticsData
    },
}
export default {
    state,
    mutations,
    actions,
    getters
}

